<template>
  <v-row dense>
    <v-col cols="12">
      <v-card :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'" elevation="0"
        class="all-trade-tab rounded-0">
        <TopPerformedIbTableFilter></TopPerformedIbTableFilter>
        <TopPerformedIbTable></TopPerformedIbTable>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

import TopPerformedIbTable from "@/components/TopPerformedIb/TopPerformedIbTable.vue";
import TopPerformedIbTableFilter from "@/components/TopPerformedIb/TopPerformedIbTableFilter.vue";

export default {
  components: {
    TopPerformedIbTable,
    TopPerformedIbTableFilter
  }
};
</script>
